import { render, staticRenderFns } from "./liveHostStat.vue?vue&type=template&id=ed49cb3c&scoped=true"
import script from "./liveHostStat.vue?vue&type=script&lang=js"
export * from "./liveHostStat.vue?vue&type=script&lang=js"
import style0 from "./liveHostStat.vue?vue&type=style&index=0&id=ed49cb3c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed49cb3c",
  null
  
)

export default component.exports